module.exports = __webpack_public_path__ + "static/zurich_b-c3019a39d052aeb2b353b0610e99af2f.svg";